import Dictionary from '../dictionary';
import DictionaryFactory from '../dictionary-factory';
import OrganizationServer from "@/api/organization";

function parseEmployees(employees) {
    for (let i = 0, len = employees.length; i < len; i++) {
        employees[i].personName = employees[i].person != null ? employees[i].person.name : employees[i].id;
    }
    return employees;
}

export const DICTIONARY_FACTORY_ORG_EMPLOYEE = 'org_employee';
export const DICTIONARY_FACTORY_ORG_EMPLOYEE_TYPE_VALID = 'VALID';
export const DICTIONARY_FACTORY_ORG_EMPLOYEE_TYPE_ALL = 'ALL';
export default class OrgEmployeeDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_ORG_EMPLOYEE});
    }

    async getDictionary({type}) {
        let dictionary;
        switch (type) {
            case DICTIONARY_FACTORY_ORG_EMPLOYEE_TYPE_VALID: {
                let employees = [];
                let response = await OrganizationServer.employee.list({eq_status: '1'});
                if (response.data.code === '200') {
                    employees = parseEmployees(response.data.data);
                }
                dictionary = new Dictionary({items: employees, valueKey: 'id', textKey: 'personName'});
                break;
            }
            case DICTIONARY_FACTORY_ORG_EMPLOYEE_TYPE_ALL: {
                let employees = [];
                let response = await OrganizationServer.employee.list({});
                if (response.data.code === '200') {
                    employees = parseEmployees(response.data.data);
                }
                dictionary = new Dictionary({items: employees, valueKey: 'id', textKey: 'personName'});
                break;
            }
        }
        if (dictionary == null) {
            dictionary = new Dictionary({items: []});
        }
        return dictionary;
    }
}